import * as React from "react";
import { ItemPageProps } from "./debate-note-item-page";
import { withSnackbar } from "../components/with-snackbar";
import { withAuthContext } from "../components/with-auth-context";
import { Content } from "../components/content";
import { Card, Fab, FormControl, Grid, LinearProgress, Button, CircularProgress, List, ListItem, Avatar, ListItemText, Typography } from "@material-ui/core";
import ListIcon from "@material-ui/icons/List";
import { UserLevel } from "../model/autogen/UserLevel";
import { SpeakingListRequestFactory } from "../model/autogen/SpeakingListController";
import { SpeakingListModel } from "../model/autogen/SpeakingListModel";
import { FilesRequestFactory } from "../model/autogen/FilesController";
import { downloadLinkResolver } from "./brief-item-page";
import { FileModel } from "../model/autogen/FileModel";
import { Iif } from "../components/iif";
import Dropzone from "react-dropzone";
import DEFAULT_DROPZONE_STYLE from "../components/dropzone-style";
import { isArrayNullOrEmpty } from "../utils/array";
import Save from "@material-ui/icons/Save";
import { Spacer } from "../components/utility-components";
import * as moment from "moment";
import ImageIcon from '@material-ui/icons/Image';

export interface ISpeakingListState {
    speakingList: SpeakingListModel;
    isUploadingFiles: boolean;
    isSaving: boolean;
    fileToAdd: FileModel;
}

export interface ISpeakingListProps extends ItemPageProps {
    speakingList: SpeakingListModel;
}


class SpeakingListPageComponent extends React.Component<ISpeakingListProps, ISpeakingListState> {
    constructor(props: ISpeakingListProps) {
        super(props);
        this.state = { isSaving: false, isUploadingFiles: false, speakingList: props.speakingList, fileToAdd: {} as FileModel };
    }

    public async componentDidMount() {
        try {
            const speakingList = await this.props.callApi((fetcher) => SpeakingListRequestFactory.getSpeakingList(fetcher))
            this.setState({ speakingList: speakingList })
        } catch (e) {
            this.props.showSnackbarMessage(`${e.statusCode}: There is not Speaking List currently available`)
        }

    }
    private onFileDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        const { callApi } = this.props;
        try {
            if (!isArrayNullOrEmpty(acceptedFiles)) {
                this.setState({ isUploadingFiles: true });
                const result = await callApi(f => FilesRequestFactory.upload(f, { file: acceptedFiles[0] }))
                this.setState({ isUploadingFiles: false, fileToAdd: result });
            }
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to upload file: ${e}`);
            this.setState({ isUploadingFiles: false });
        }
    }
    private download = async (fileModel: FileModel | undefined) => {
        if (fileModel) {
            const result = await this.props.callApi((fetcher) => FilesRequestFactory.requestDownload(fetcher, fileModel.id));
            const downloadLink = downloadLinkResolver(result.id);
            if (fileModel.mimeType === "application/pdf") {
                window.open(downloadLink)
            } else {
                window.location.href = downloadLink;
            }
        }
    }

    private onSave = async (e: any) => {
        if (this.state.speakingList !== undefined) {
            const { speakingList, fileToAdd } = this.state;
            speakingList.assignFile = fileToAdd;
            const payload = speakingList;
            const { callApi, showSnackbarMessage } = this.props;
            this.setState({ isSaving: true });
            try {
                const result = await callApi((fetcher) => SpeakingListRequestFactory.update(fetcher, payload))
                showSnackbarMessage(payload.id > 0 ? 'Speaking List Saved' : `New Speaking List Saved (${result.id})`);
                
                this.setState({ isSaving: false, speakingList: result, fileToAdd: {} as FileModel });
            } catch (e) {
                showSnackbarMessage(`${e.body}`)
                this.setState({ isSaving: false });
            }
        } else {
            const payload = this.state.fileToAdd
            const { callApi, showSnackbarMessage } = this.props;
            try {
                const result = await callApi((fetcher) => SpeakingListRequestFactory.create(fetcher, payload))
                showSnackbarMessage(payload.id > 0 ? 'Speaking List Saved' : `New Speaking List Saved (${result.id})`);
                
                this.setState({ isSaving: false, speakingList: result, fileToAdd: {} as FileModel });
            } catch (e) {
                showSnackbarMessage(`${e}`)
                this.setState({ isSaving: false });
            }
        }
    }

    public render() {
        const { speakingList, fileToAdd, isUploadingFiles, isSaving } = this.state;
        return <Content>
            <h1>Speaking List</h1>
            <Card>
                <Content>
                    <Fab variant="extended" color="primary" aria-label="View Speaking List" onClick={speakingList ? async () => await this.download(speakingList.file) : undefined} disabled={!speakingList || speakingList.file === null}>
                        <ListIcon />
                        View Speaking List
                    </Fab>
                    <Spacer />
                    <Iif show={this.props.user.level >= UserLevel.Editor}>
                        <FormControl>
                            {speakingList !== undefined && <List>
                                <Typography variant="caption">Current Speaking List</Typography>
                                <ListItem key={speakingList.file.id}>
                                    <Avatar>
                                        <ImageIcon />
                                    </Avatar>
                                        <ListItemText
                                            primary={<a href={'#'}>{speakingList.file.fileName}</a>} secondary={`Uploaded: ${moment.utc(speakingList.file.date).format("ddd DD MMM YYYY")}`}
                                        />
                                </ListItem>
                            </List>}
                            <Typography variant="caption">Update Speaking List</Typography>
                            <Dropzone multiple={false} onDrop={this.onFileDrop} style={DEFAULT_DROPZONE_STYLE.default} disabledStyle={DEFAULT_DROPZONE_STYLE.disabled} activeStyle={DEFAULT_DROPZONE_STYLE.active} acceptStyle={DEFAULT_DROPZONE_STYLE.active} rejectStyle={DEFAULT_DROPZONE_STYLE.rejected}>
                                <Grid justify="center" container spacing={24}>
                                    <Grid item xs={6}>
                                        {(() => {
                                            if (fileToAdd.id > 0) {
                                                return <>
                                                    {isUploadingFiles && <LinearProgress />}
                                                    <p style={DEFAULT_DROPZONE_STYLE.text}>New Speaking List</p>
                                                    <p style={DEFAULT_DROPZONE_STYLE.text}>{fileToAdd.fileName}</p>
                                                </>;
                                            } else {
                                                return <>
                                                    {isUploadingFiles && <LinearProgress />}
                                                    <p style={DEFAULT_DROPZONE_STYLE.text}>Click here or drag/drop a file to upload it</p>
                                                </>;
                                            }
                                        })()}
                                    </Grid>
                                </Grid>
                            </Dropzone>
                            <Button variant="contained" fullWidth={true} onClick={this.onSave} disabled={isSaving} color="primary">
                                {isSaving ? <CircularProgress size={24} /> : <Save />}{isSaving ? " Saving ..." : " Save"}
                            </Button>
                        </FormControl>
                    </Iif>
                </Content>
            </Card>
        </Content>
    }

}

export const SpeakingListPage = withSnackbar(withAuthContext(SpeakingListPageComponent) as any);


// WEBPACK FOOTER //
// ./src/pages/speaking-list-page.tsx